import { Observable } from "rxjs";
export default class RxUtils {
    static fromQuery(query) {
        return new Observable(observer => {
            const subscription = query.subscribe({
                next: (data) => observer.next(data),
                error: error => observer.error(error),
                complete: () => observer.complete()
            });
            return () => {
                subscription.unsubscribe();
            };
        });
    }
}
